"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidIsoDate = void 0;
const luxon_1 = require("luxon");
function isValidIsoDate(date) {
    if (!date || date.length < 8) {
        return false;
    }
    return (luxon_1.DateTime.fromFormat(date, 'yyyy-MM-dd').isValid ||
        luxon_1.DateTime.fromFormat(date, 'MM/dd/yyyy').isValid ||
        luxon_1.DateTime.fromFormat(date, 'yyyyMMdd').isValid ||
        luxon_1.DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss.SSS').isValid ||
        luxon_1.DateTime.fromFormat(date, `yyyy-MM-dd'T'HH:mm:ss.SSSZZZ`).isValid ||
        luxon_1.DateTime.fromISO(date).isValid);
}
exports.isValidIsoDate = isValidIsoDate;
//# sourceMappingURL=index.js.map